<!-- 打印单个标签 -->
<template>
    <div v-loading="!canRequest">
        <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%; padding-right: 30px" :rules="rules">
            <div class="form-main">
                <div class="print-msg">{{ printMsg }}</div>
            </div>
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="包装规格" prop="PackingSpec">
                        <el-input placeholder="数量" v-model="submitData.PackingSpec" @focus="focusSpec" @blur="blurSpec" @change="SpecChange">
                            <template slot="append">{{ unit }}</template>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="标签张数" prop="Amount">
                        <el-input-number style="width: 100%" v-model.trim="submitData.Amount" :max="Math.floor(canPrintCount / submitData.PackingSpec)" :min="1">
                        </el-input-number>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="submitForm" :disabled="!isCanSubmit">打印</el-button>
            <el-button @click="cancel()" :disabled="!isCanSubmit">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        EntpGoodsIds: Array,
    },
    components: {},
    data() {
        return {
            printMsg: '打印该标签仅展示商品属性，标签无法进行出入仓操作。勾选的商品将根据输入的规格及张数展示打印属性标签。',
            canRequest: true,
            canPrintCount: 99,
            unit: '件',
            isCanSubmit: true,
            submitData: {
                PackingSpec: 1,
                GoodsIds: [],
                Amount: ''
            },
            rules: {
                PackingSpec: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Amount: [{ required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.submitData.GoodsIds = this.EntpGoodsIds;
    },
    methods: {
        submitForm() {
            this.$refs.formMsg.validate(valid => {
                if (valid) {
                    if (this.submitData.Amount > 0 && this.isCanSubmit) {
                        if (!this.canRequest) {
                            return;
                        }
                        this.canRequest = false;

                        this.$util
                            .axiosPost({
                                url: '/api/EntpGoodsLabels/PrintSingAttrGoodsLabels',
                                data: this.submitData,
                                hideLoading: true
                            })
                            .then(res => {
                                setTimeout(() => {
                                    this.canRequest = true;
                                }, 1000);
                                this.$util.successMsg(res.errmsg);
                                this.$emit('closeDialog', true);
                            })
                            .catch(() => {
                                this.canRequest = true;
                            });
                        
                    } else this.$util.warningMsg('打印张数必须大于0');
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        SpecChange(val) {
            this.submitData.Amount = 1;
        },
        focusSpec() {
            this.isCanSubmit = false;
        },
        blurSpec() {
            setTimeout(() => {
                this.isCanSubmit = true;
            }, 500);
        },
    }
};
</script>
<style lang="less" scoped>
.form-main {
    display: flex;
}
.dialog-footer {
    text-align: right;
}
.print-msg {
    margin-bottom: 15px;
    font-size: 16px;
    color: rgb(238, 122, 122);
}
</style>
